import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, useMapEvents, useMap } from "react-leaflet";
import L from "leaflet";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png",
  iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png",
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png",
});

function ClickHandler({ onPick }) {
  useMapEvents({
    click(e) {
      onPick({ lat: e.latlng.lat, lng: e.latlng.lng });
    },
  });
  return null;
}

function Recenter({ center }) {
  const map = useMap();
  useEffect(() => {
    if (center) map.setView(center, map.getZoom());
  }, [center, map]);
  return null;
}

export default function LocationPicker({ value, onChange, height = 300, readOnly = false }) {
  // Default map center: geographic center of contiguous USA (nationwide service). Falls back to user's picked location if provided.
  const center = value ? [value.lat, value.lng] : [39.8283, -98.5795];

  return (
    <div style={{ height, width: "100%" }} className="rounded-md overflow-hidden border-2 border-asap-deep" data-testid="location-picker">
      <MapContainer center={center} zoom={value ? 13 : 4} style={{ height: "100%", width: "100%" }} scrollWheelZoom>
        <TileLayer attribution='&copy; OpenStreetMap' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {!readOnly && <ClickHandler onPick={onChange} />}
        {value && <Marker position={[value.lat, value.lng]} />}
        {value && <Recenter center={[value.lat, value.lng]} />}
      </MapContainer>
    </div>
  );
}
